module.exports = __webpack_public_path__ + "static/img/0763.fc21f6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0763.jpg
// module id = 102
// module chunks = 0